module.exports = __webpack_public_path__ + "img/acmedcont1.e8160401.png";